/**
 * Event tracking constants for the Request Upgrade pop-up, wherever a Plus upsell opens it
 */

const FEATURE_CLICKED = 'feature_clicked' as const;
const TAB = 'plus_upgrade' as const;

/**
 * The Plus upsell a Request Upgrade pop-up was opened from. A new upsell adds its own.
 */
export type PlusUpsellSource =
  | 'home_plus_card'
  | 'upgrades_page'
  | 'upgrades_page_results'
  | 'managed_repeats_paywall'
  | 'website_builder_paywall'
  | 'super_links_paywall'
  | 'in_app_banners_paywall'
  | 'broadcast_promotion'
  | 'broadcast_targeting'
  | 'broadcast_refused'
  | 'sms_promotional_campaign';

/**
 * All Request Upgrade pop-up events. Each carries custom_params with the source, the page, the
 * organisation and whether it had already asked for Plus.
 */
export const PLUS_UPGRADE_EVENTS = {
  POPUP_OPENED: {
    action: 'plus_upgrade_popup_opened',
    type: FEATURE_CLICKED,
    tab: TAB,
  },
  // The request reached account management, including one they already had
  REQUESTED: {
    action: 'plus_upgrade_requested',
    type: FEATURE_CLICKED,
    tab: TAB,
  },
  // Closed without a request
  POPUP_DISMISSED: {
    action: 'plus_upgrade_popup_dismissed',
    type: FEATURE_CLICKED,
    tab: TAB,
  },
} as const;
